import React, { useEffect, useState, useRef } from 'react'
import style from './index.module.scss'
import { Dropdown, MenuProps } from 'antd';
import { FilterOutlined } from '@ant-design/icons';
import useStore from '../../store/useStore'
import MsgItem from './msgitem';
import MsgInput from './msginput';
import { createDis, getDisInfo, postDisContent, getOptionsByDis, getOptionsByOption, getChatInfo } from '../../api/discussion';
import msgicon from './msgicon.png';
import quoteicon from './quoteicon.png';
import ping from './ping.png';
import filter from './filter.png';
// import { arrayNumEqual } from './util';
import { deepCopy, getImgUrlById } from '../../util';
import { memoadduser } from '../../api/chat';

interface Props {
    visible?: boolean;
    onClose: () => void;
}

interface State {
}

const Chat = (props: Props) => {
    const [discussion, setdiscussion] = useState<any>({});

    const [limit, setlimit] = useState<any>(1000);
    const [newest, setnewest] = useState<any>(false);
    const [list, setList] = useState<any[]>([]);
    let msgList = useRef<any>([]);

    const [contentpopvisi, setcontentpopvisi] = useState<boolean>(false);
    const [contentpoppos, setcontentpoppos] = useState<any>({});

    const [replyitem, setreplyitem] = useState<any>(null);
    const [quoteitems, setquoteitems] = useState<any[]>([]);
    const [activemsg, setactivemsg] = useState<any>(null);

    const [showChat, setshowChat] = useState<boolean>(false);
    const [showQuoteCheck, setshowQuoteCheck] = useState<boolean>(false);
    // const [quoteChecks, setquoteChecks] = useState<any[]>([]);
    const [expandpage, setexpandpage] = useState<boolean>(false);
    const [order, setorder] = useState<'send' | 'talk'>('talk');
    const [focusId, setFocusId] = useState<string>('');

    const inputref = useRef<any>();

    const { store, dispatch } = useStore();
    // const closeclick = (e: any) => {
    //     const roll = (item: any): boolean => {
    //         if (item.getAttribute("class") === 'x6-graph-svg') {
    //             return true;
    //         } else if (item.parentElement && item.parentElement.tagName !== 'BODY') {
    //             return roll(item.parentElement)
    //         } else {
    //             return false;
    //         }
    //     }
    //     const isSvg = roll(e.target);
    //     if (isSvg) {
    //         dispatch({
    //             type: 'SET_SHOWCHAT',
    //             data: false
    //         });
    //         dispatch({
    //             type: 'SET_CHATID',
    //             data: ''
    //         });
    //         dispatch({
    //             type: 'SET_CHATDISCUSSIONID',
    //             data: ''
    //         });
    //     }
    // }
    // useEffect(() => {
    //     window.addEventListener('click', closeclick);
    //     return () => {
    //         window.removeEventListener('click', closeclick);
    //     }
    // }, []);

    useEffect(() => {
        setshowChat(store.showChat);
        if (!store.showChat) {
            setList([]);
            msgList.current = []

        }
    }, [store.showChat]);

    useEffect(() => {
        initDisInfo(store.chatDiscussionId, store.chatId);
    }, [store.chatDiscussionId, store.chatId]);
    useEffect(() => {
        console.log('lailediscussion')
        getList();
    }, [discussion]);
    useEffect(() => {
        if (store.chatMsg) {
            console.log('laile', store.chatMsg, store.chatDiscussionId, store.chatId)
            // getList('last');
            setTimeout(() => {
                getOptionsByOptionItem()
            }, 500);
            // getReplyAndQuoteDetail([store.chatMsg], true);
        }
    }, [store.chatMsg]);
    const getOptionsByOptionItem = async () => {
        try {
            const chatInfores: any = await getChatInfo(discussion.chatId);
            const {
                ownerInfo = {},
                usersInfo = []
            } = chatInfores.data;
            const users = usersInfo.concat([ownerInfo]);

            const res: any = await getOptionsByOption(store.chatMsg.messageId);
            console.log('getOptionsByOptionItem', msgList.current, res.data)
            const itemuser = users.find((user: any) => {
                return user.id === res.data.senderId
            }) || {};
            res.data.avatar = getImgUrlById(itemuser.avatar) || '';
            res.data.name = itemuser.username;
            if (res.data.reply) {
                const optionres = await getOptionsByOption(res.data.reply);
                res.data.replyData = optionres?.data || null;
                let _msgList: any = deepCopy(msgList.current)
                _msgList.map((i: any) => {
                    if (i.id == res.data.reply) {
                        i.byReply = optionres?.data.byReply
                    }
                })
                msgList.current = _msgList
                console.log('getOptionsByOptionItem1', _msgList, msgList.current, optionres?.data)
            }
            msgList.current = msgList.current.concat([res.data])
            setList([...list, ...[res.data]])
            // if (res.data) {
            //     const reslist = await getReplyAndQuoteDetail([res.data]);
            //     console.log('reslist', reslist)
            //     setList([...list, ...reslist] || []);
            if (res.data) {
                // setTimeout(() => {
                const el: any = document.getElementById(res.data.id);
                el.parentElement.scrollTop = el.offsetTop + 45;
                // }, 500);
                setFocusId(res.data.id);
                setTimeout(() => {
                    setFocusId('');
                }, 5000);
            }
            // }
        } catch (e) { console.log('e', e) }
    }
    const inputfocus = () => {
        return
        inputref.current.focus({
            cursor: 'end',
        });
    };
    const toReply = (id: string) => {
        const el: any = document.getElementById(id);
        el.parentElement.scrollTop = el.offsetTop - 45;
        setFocusId(id);
        setTimeout(() => {
            setFocusId('');
        }, 5000);
    }
    const toquote = (id: string) => {
        const el: any = document.getElementById(id);
        el.parentElement.scrollTop = el.offsetTop - 45;
        setFocusId(id);
        setTimeout(() => {
            setFocusId('');
        }, 5000);
    }
    // 图钉按钮点击
    const pingClick = () => {
        const { x = 0, y = 0 } = (window as any).graphItem.getCellById(store.chatId).store.data.position || {}
        const width = (window.innerWidth - 480) / 2;
        const height = (window.innerHeight - 100) / 2;
        (window as any).graphItem.translate(width - x - 60, height - y - 60);
    }
    // 获取观点相关的回复与引用内容
    const getReplyAndQuoteDetail = async (infoList: any[], notreset?: boolean) => {
        const chatInfores: any = await getChatInfo(discussion.chatId);
        const {
            ownerInfo = {},
            usersInfo = []
        } = chatInfores.data;
        const users = usersInfo.concat([ownerInfo]);
        if (!notreset) {
            setList([...infoList]);
            msgList.current = infoList
        }
        await Promise.all(infoList.map(async (v: any, k: number) => {
            const itemuser = users.find((user: any) => {
                return user.id === v.senderId
            }) || {};
            v.avatar = getImgUrlById(itemuser.avatar) || '';
            v.name = itemuser.username;
            if (v.quote && v.quote.length) {
                const optionsList = await Promise.all(v.quote.map(async (item: any) => {
                    const optionres = await getOptionsByOption(item);
                    return optionres?.data || {};
                }));
                optionsList.forEach((o: any) => {
                    const ouser = users.find((user: any) => {
                        return user.id === o.senderId
                    }) || {};
                    o.avatar = getImgUrlById(itemuser.avatar) || '';
                    o.name = itemuser.username;
                })
                v.quoteData = optionsList || [];
            }
            console.log('v.reply', v.reply)
            if (v.reply) {
                const optionres = await getOptionsByOption(v.reply);
                v.replyData = optionres?.data || null;
            }
            const optionres = await getOptionsByOption(v.id);
            v.byReply = optionres?.data?.byReply || [];
            if (!notreset) {
                setList([...infoList]);
                msgList.current = infoList
            }
            return '';
        }));
        console.log('infoList', infoList, notreset)
        return infoList;
    }

    // 获取聊天会话记录
    const getList = async (type?: any) => {
        console.log('获取了getList')
        if (discussion.id) {
            const res = await getOptionsByDis(discussion.id, {
                limit,
                newest
            });
            const msglist = res?.data || [];
            if (type == 'last') {
                //ws或者单发消息时触发
                const reslist = await getReplyAndQuoteDetail([msglist[msglist.length - 1]]);
                console.log('reslist', reslist)
                setList([...list, ...reslist] || []);
                msgList.current = msgList.current.concat([reslist])
                if (reslist) {
                    setTimeout(() => {
                        const el: any = document.getElementById(reslist[0].id);
                        console.log('elelel', reslist, el.offsetTop, el.parentElement)
                        el.parentElement.scrollTop = el.offsetTop + 45;
                    }, 500);
                    setFocusId(reslist[0].id);
                    setTimeout(() => {
                        setFocusId('');
                    }, 5000);
                }
            } else {
                //刚进入页面触发
                const reslist = await getReplyAndQuoteDetail(msglist);
                setList([...reslist] || []);
                msgList.current = reslist

            }
        }
        dispatch({
            type: 'SET_NEW_CHAT',
            data: false
        })
    }

    // 获取聊天基本信息
    const initDisInfo = async (chatDiscussionId: any, chatId: any) => {
        //如果不是聊天列表，就不用弹出
        if (!store.showChat) return
        let discussionId = chatDiscussionId;
        if (chatId && !discussionId) {
            const dis = await createDis(chatId);
            discussionId = dis?.data;
        }
        if (chatId && discussionId) {
            await memoadduser(discussionId, [
                store.userInfo.id
            ]);
            const info = await getDisInfo(chatId, discussionId);
            setdiscussion(info?.data || {});
        }
    }

    // 发送消息
    const sendMsg = async (str: string) => {
        // todo
        const res = await postDisContent(discussion.memoId, discussion.id, {
            "id": discussion.chatId,
            "memoId": discussion.memoId,
            "discussionId": discussion.id,
            "reply": replyitem?.id || undefined,
            "quote": (quoteitems && quoteitems.length) ?
                quoteitems.map((v: any) => (v.id)) :
                undefined,
            "content": str,
            'topicId': store.subjectInfo.subjectId
        });
        clearSelect();
        setshowQuoteCheck(false);
        // await getList('last');
        // if (res?.data) {
        //     setTimeout(() => {
        //         const el: any = document.getElementById(res?.data);
        //         console.log('elelel1', res?.data, el.offsetTop, el.parentElement)
        //         el.parentElement.scrollTop = el.offsetTop - 45;
        //     }, 500);
        //     setFocusId(res?.data);
        //     setTimeout(() => {
        //         setFocusId('');
        //     }, 5000);
        // }
    }
    // 点击展开引用
    const onExpendQuote = async (event: any, msg: any, nav?: any) => {
        msg.expandquote = !nav;
        setList([...list]);
        msgList.current = msgList.current


    }
    // 点击消息内容
    const onContentClick = (event: any, msg: any) => {
        event.stopPropagation();
        event.preventDefault();
        const {
            clientX,
            clientY
        } = event;
        setcontentpopvisi(true);
        setcontentpoppos({
            x: clientX,
            y: clientY
        });
        setactivemsg(msg);
    }
    // 点击展开内容
    const onExpendClick = async (event: any, msg: any, nav?: boolean) => {
        event.stopPropagation();
        if (!nav) {
            if (!msg.byReplyData || !msg.byReplyData.length) {
                const responseList = await Promise.all(msg.byReply.map((v: any) => {
                    return getOptionsByOption(v);
                }))
                const datalist = responseList.map((v: any) => {
                    return v?.data || {};
                })
                await getReplyAndQuoteDetail(datalist, true);
                msg.byReplyData = datalist || [];
            }
            msg.expand = true;
        } else {
            msg.expand = false;
        }
        setList([...list]);
        msgList.current = msgList.current
    }
    const onClickExpendPage = async (event: any, msg: any) => {
        setexpandpage(true);
    }
    // 隐藏弹窗
    const hidepop = () => {
        setcontentpopvisi(false);
        setcontentpoppos(null);
        setactivemsg(null);
    }
    // 点击回复
    const reply = () => {
        setreplyitem(activemsg);
        setcontentpopvisi(false);
        setcontentpoppos(null);
        setactivemsg(null);
        inputfocus();
    }
    // 点击引用
    const quote = () => {
        const has = quoteitems.find(v => {
            return v.id === activemsg.id
        })
        if (!has) {
            setquoteitems([...quoteitems, activemsg]);
        }
        setcontentpopvisi(false);
        setcontentpoppos(null);
        setactivemsg(null);
        inputfocus();
    }

    const removereply = (v: any) => {
        setreplyitem('');
    }
    // 点击引用
    const removequote = (v: any) => {
        const idx = quoteitems.findIndex(item => {
            return item.id === v.id
        })
        if (idx > -1) {
            quoteitems.splice(idx, 1)
            setquoteitems([...quoteitems]);
        }
    }
    // 清楚选择内容，重置所有已选内容
    const clearSelect = () => {
        setcontentpopvisi(false);
        setcontentpoppos(null);
        setactivemsg(null);
        setreplyitem(null);
        setquoteitems([]);
    }
    // 点击引用
    const quoteClick = () => {
        if (showQuoteCheck) {
            setshowQuoteCheck(false);
        } else {
            setshowQuoteCheck(true);
        }
        // setquoteChecks([]);
    }
    // 选中引用消息的复选框
    const onQuoteCheckChange = (e: any, msg: any, path: number[]) => {
        const idx = quoteitems.findIndex(v => {
            return v.id === msg.id
        })
        if (e.target.checked) {
            if (idx === -1) {
                setquoteitems([...quoteitems, msg]);
            }
        } else {
            if (idx > -1) {
                quoteitems.splice(idx, 1);
                setquoteitems([...quoteitems]);
            }
        }
        // let arrItem: any = '';
        // let arrIdx: any = undefined;
        // quoteChecks.forEach((item, k) => {
        //     const isequal = arrayNumEqual((item.path || []), path);
        //     if (isequal) {
        //         arrItem = item;
        //         arrIdx = k;
        //     }
        // });
        // if (arrItem) {
        //     if (arrItem?.msg?.id === msg.id) {
        //         quoteChecks.splice(arrIdx, 1);
        //     } else {
        //         quoteChecks.splice(arrIdx, 1, {
        //             msg: arrItem,
        //             path: path
        //         });
        //     }
        // } else {
        //     quoteChecks.push({
        //         msg: arrItem,
        //         path: path
        //     });
        // }
        // setquoteChecks([...quoteChecks]);
    }
    // 切换顺序
    const changeOrder = (type: 'talk' | 'send') => {
        setorder(type)
    }

    const filtermenu: MenuProps['items'] = [{
        key: '1',
        label: (<div className={style.menu}
            onClick={() => {
                changeOrder('send')
            }}>
            按发言顺序
        </div>)
    }, {
        key: '2',
        label: (<div className={style.menu}
            onClick={() => {
                changeOrder('talk')
            }}>
            按讨论顺序
        </div>)
    }];

    const render = (
        <>
            <>
                {store.showChat && <div className='CLOSESHOWALL'>
                </div>}</>
            <>{store.showChat && <div className={style.chatout}>
                <div className={style.content + ' ' + (expandpage ? style.expand : '')}
                    onClick={(e) => {
                        e.stopPropagation();
                        hidepop();
                    }}>
                    {
                        !expandpage ?
                            <div className={style.top}>
                                <div className={style.title}>{
                                    store.showChatType === 'theme' ? '主题讨论' : '讨论'
                                }</div>
                                <div className={style.append}>
                                    {
                                        store.showChatType !== 'theme' ?
                                            <div className={style.appendpingout}
                                                onClick={pingClick}>
                                                <img src={ping}
                                                    className={style.appendping}
                                                ></img>
                                            </div> : null
                                    }
                                    <div className={style.appendquoteout}
                                        onClick={quoteClick}>
                                        <img src={quoteicon}
                                            className={style.appendquote + " " + (showQuoteCheck ? 'on' : '')}
                                        ></img>
                                    </div>
                                    <Dropdown menu={{
                                        items: filtermenu
                                    }}
                                        placement="bottomRight">
                                        <div className={style.appendfilterout}>
                                            <img src={filter}
                                                className={style.appendfilter} />
                                        </div>
                                    </Dropdown>
                                </div>
                            </div> : null
                    }
                    {
                        expandpage ?
                            <div className={style.navexpendpage}
                                onClick={() => {
                                    setexpandpage(false);
                                }}>
                                收起回复
                            </div> : null
                    }
                    <MsgItem
                        focusId={focusId}
                        order={order}
                        showQuoteCheck={showQuoteCheck}
                        onQuoteCheckChange={onQuoteCheckChange}
                        quoteitems={quoteitems}
                        list={msgList.current}
                        deep={1}
                        path={[]}
                        expandpage={expandpage}
                        onExpendClick={onExpendClick}
                        onContentClick={onContentClick}
                        onExpendQuote={onExpendQuote}
                        onClickExpendPage={onClickExpendPage}
                        toReply={toReply}
                        toquote={toquote}></MsgItem>
                    <MsgInput onSend={(str: string) => {
                        sendMsg(str);
                    }}
                        ref={inputref}
                        removereply={removereply}
                        removequote={removequote}
                        reply={replyitem}
                        quotes={quoteitems} />
                    {
                        contentpopvisi && <div className={style.contentpop}
                            onClick={(e) => {
                                e.stopPropagation();
                            }}
                            style={{
                                display: `${contentpoppos ? 'flex' : 'none'}`,
                                left: `${contentpoppos?.x}px`,
                                top: `${contentpoppos?.y}px`
                            }}>
                            <div className={style.popline}
                                onClick={() => {
                                    reply();
                                }}>
                                <div className={style.popicon}>
                                    <img src={msgicon} />
                                </div>
                                <div className={style.poptxt}>回复</div>
                            </div>
                            <div className={style.popline}
                                onClick={() => {
                                    quote();
                                }}>
                                <div className={style.popicon}>
                                    <img src={quoteicon} />
                                </div>
                                <div className={style.poptxt}>引用</div>
                            </div>
                        </div>
                    }
                </div>
            </div>}</></>
    )

    return showChat ? render : null
}

export default Chat;
